export const leftNavClickTypes = {
  CLICK_HOME: 'LEFT_HOME_CLICK',
  CLICK_SCHOOLS: 'LEFT_SCHOOLS_CLICK',
  CLICK_EXPERTS: 'LEFT_EXPERTS_CLICK',
  CLICK_GROUPS: 'LEFT_GROUPS_CLICK',
  CLICK_ARTICLES: 'LEFT_ARTICLES_CLICK',
};
export const modalTypes = {
  SELECTED_TEAM_MODAL_OPEN: 'SELECTED_TEAM_MODAL_OPEN',
  SET_MODAL_ACTION: 'SET_MODAL_ACTION',
};
